import { useState } from 'react';
import { Star, MapPin, Wifi, Car, Utensils, Waves, ChevronLeft, ChevronRight, Heart } from 'lucide-react';
import Button from '../base/Button';

export default function HotelsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [favorites, setFavorites] = useState<number[]>([]);
  const [activeFilter, setActiveFilter] = useState<string>('Tous');

  const hotels = [
    {
      id: 1,
      name: "Rixos Premium Dubai",
      location: "JBR Beach",
      rating: 5,
      reviews: 2847,
      price: "484",
      originalPrice: "968",
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/HOTEL-RIXOS-PREMIUM-JBR-.jpg",
      amenities: [Wifi, Car, Utensils, Waves],
      badge: "Luxe",
      category: "Plage",
      description: "Resort 5 étoiles face à la plage avec spa et restaurants gastronomiques",
      highlights: ["Plage privée", "Spa de luxe", "5 restaurants", "Piscine infinity"]
    },
    {
      id: 2,
      name: "Al Qasr Madinat Jumeirah",
      location: "Madinat Jumeirah",
      rating: 5,
      reviews: 1923,
      price: "484",
      originalPrice: "650",
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/01Al-Qasr-hotel-at-Madinat-Jumeirah-_mzrbnd.jpg.webp",
      amenities: [Wifi, Car, Utensils, Waves],
      badge: "Authentique",
      category: "Luxe",
      description: "Palais arabe authentique avec architecture traditionnelle",
      highlights: ["Architecture arabe", "Souk privé", "Canaux vénitiens", "Vue Burj Al Arab"]
    },
    {
      id: 3,
      name: "Atlantis The Palm",
      location: "Palm Jumeirah",
      rating: 5,
      reviews: 3241,
      price: "435",
      originalPrice: "580",
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/01Hotel-and-resort-Atlantis-the-island-Palm-Desktop-Wallpaper-HD-5200x3250-1920x1080_v2kmlb.jpg.webp",
      amenities: [Wifi, Car, Utensils, Waves],
      badge: "Famille",
      category: "Famille",
      description: "Resort iconique avec aquarium géant et parc aquatique",
      highlights: ["Aquaventure", "Aquarium géant", "Plage privée", "Restaurants étoilés"]
    },
    {
      id: 4,
      name: "Bulgari Resort Dubai",
      location: "Jumeira Bay",
      rating: 5,
      reviews: 892,
      price: "1210",
      originalPrice: "1450",
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/bulgari-evening_f42jxj.jpg.webp",
      amenities: [Wifi, Car, Utensils, Waves],
      badge: "Ultra Luxe",
      category: "Luxe",
      description: "Resort ultra-luxe sur île privée avec marina exclusive",
      highlights: ["Île privée", "Marina exclusive", "Spa Bulgari", "Yacht club"]
    },
    {
      id: 5,
      name: "Address Downtown Dubai",
      location: "Downtown Dubai",
      rating: 5,
      reviews: 2156,
      price: "385",
      originalPrice: "520",
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/ce21d131464d69f89d14ea294961b6f00dc75489-1.jpg.webp",
      amenities: [Wifi, Car, Utensils, Waves],
      badge: "Ville",
      category: "Ville",
      description: "Hôtel moderne au cœur de Downtown avec vue sur Burj Khalifa",
      highlights: ["Vue Burj Khalifa", "Dubai Mall", "Métro direct", "Spa"]
    },
    {
      id: 6,
      name: "One&Only Royal Mirage",
      location: "Dubai Marina",
      rating: 5,
      reviews: 1789,
      price: "520",
      originalPrice: "680",
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/HOTEL-RIXOS-PREMIUM-JBR-.jpg",
      amenities: [Wifi, Car, Utensils, Waves],
      badge: "Spa",
      category: "Spa",
      description: "Resort de luxe avec spa renommé et plage privée",
      highlights: ["Spa Guerlain", "Plage privée", "3 piscines", "Restaurants étoilés"]
    },
    {
      id: 7,
      name: "Jumeirah Beach Hotel",
      location: "Jumeirah Beach",
      rating: 5,
      reviews: 3421,
      price: "425",
      originalPrice: "560",
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/bulgari-evening_f42jxj.jpg.webp",
      amenities: [Wifi, Car, Utensils, Waves],
      badge: "Famille",
      category: "Famille",
      description: "Hôtel familial avec accès gratuit à Wild Wadi Waterpark",
      highlights: ["Wild Wadi inclus", "Plage privée", "Kids club", "Piscines multiples"]
    },
    {
      id: 8,
      name: "Armani Hotel Dubai",
      location: "Burj Khalifa",
      rating: 5,
      reviews: 1234,
      price: "680",
      originalPrice: "850",
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/01Hotel-and-resort-Atlantis-the-island-Palm-Desktop-Wallpaper-HD-5200x3250-1920x1080_v2kmlb.jpg.webp",
      amenities: [Wifi, Car, Utensils, Waves],
      badge: "Luxe",
      category: "Ville",
      description: "Hôtel de luxe signé Armani au cœur de la Burj Khalifa",
      highlights: ["Burj Khalifa", "Design Armani", "Spa exclusif", "Restaurants étoilés"]
    }
  ];

  const filteredHotels = activeFilter === 'Tous' 
    ? hotels 
    : hotels.filter(hotel => hotel.category === activeFilter);

  const itemsPerPage = 3;
  const maxIndex = Math.max(0, filteredHotels.length - itemsPerPage);

  const nextSlide = () => {
    setCurrentIndex(prev => Math.min(prev + 1, maxIndex));
  };

  const prevSlide = () => {
    setCurrentIndex(prev => Math.max(prev - 1, 0));
  };

  const toggleFavorite = (id: number) => {
    setFavorites(prev => 
      prev.includes(id) 
        ? prev.filter(fav => fav !== id)
        : [...prev, id]
    );
  };

  const handleFilterChange = (filter: string) => {
    setActiveFilter(filter);
    setCurrentIndex(0);
  };

  return (
    <section className="py-20 bg-white" id="hotels">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Hôtels <span className="text-amber-600">d'Exception</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Sélection exclusive d'hôtels 5 étoiles et resorts de luxe. 
            Réservation au meilleur prix avec notre garantie satisfaction.
          </p>
          
          {/* Hotel categories */}
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            {['Tous', 'Plage', 'Ville', 'Luxe', 'Famille', 'Spa'].map((category) => (
              <button
                key={category}
                onClick={() => handleFilterChange(category)}
                className={`px-6 py-2 rounded-full transition-all ${
                  activeFilter === category
                    ? 'bg-amber-600 text-white shadow-lg' 
                    : 'bg-white text-gray-700 hover:bg-amber-50 border border-gray-200'
                }`}
              >
                {category} {activeFilter === category && `(${filteredHotels.length})`}
              </button>
            ))}
          </div>
        </div>

        {/* Hotels Carousel */}
        <div className="relative">
          {/* Navigation buttons */}
          <button
            onClick={prevSlide}
            disabled={currentIndex === 0}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-600 hover:text-amber-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
          >
            <ChevronLeft size={24} />
          </button>
          
          <button
            onClick={nextSlide}
            disabled={currentIndex >= maxIndex}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-600 hover:text-amber-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
          >
            <ChevronRight size={24} />
          </button>

          {/* Hotels Grid */}
          <div className="overflow-hidden">
            {filteredHotels.length === 0 ? (
              <div className="text-center py-12">
                <p className="text-gray-500 text-lg">Aucun hôtel trouvé pour cette catégorie.</p>
              </div>
            ) : (
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentIndex * (100 / itemsPerPage)}%)` }}
              >
                {filteredHotels.map((hotel) => (
                <div key={hotel.id} className="w-1/3 flex-shrink-0 px-3" data-product-shop>
                  <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group">
                    {/* Image */}
                    <div className="relative overflow-hidden">
                      <img
                        src={hotel.image}
                        alt={hotel.name}
                        className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      
                      {/* Badge */}
                      <div className="absolute top-4 left-4">
                        <span className="bg-amber-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                          {hotel.badge}
                        </span>
                      </div>
                      
                      {/* Favorite button */}
                      <button
                        onClick={() => toggleFavorite(hotel.id)}
                        className="absolute top-4 right-4 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors"
                      >
                        <Heart 
                          size={20} 
                          className={favorites.includes(hotel.id) ? 'text-red-500 fill-current' : 'text-gray-600'} 
                        />
                      </button>
                      
                      {/* Price overlay */}
                      <div className="absolute bottom-4 right-4 bg-white/95 backdrop-blur-sm rounded-lg px-3 py-2">
                        <div className="text-right">
                          <div className="text-lg font-bold text-amber-600">€{hotel.price}</div>
                          <div className="text-sm text-gray-500 line-through">€{hotel.originalPrice}</div>
                          <div className="text-xs text-gray-600">par nuit</div>
                        </div>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-6">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center space-x-1">
                          {[...Array(hotel.rating)].map((_, i) => (
                            <Star key={i} className="text-amber-400 fill-current" size={16} />
                          ))}
                          <span className="text-gray-500 text-sm ml-2">({hotel.reviews} avis)</span>
                        </div>
                        <div className="flex items-center text-gray-500 text-sm">
                          <MapPin size={14} className="mr-1" />
                          {hotel.location}
                        </div>
                      </div>

                      <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-amber-600 transition-colors">
                        {hotel.name}
                      </h3>

                      <p className="text-gray-600 text-sm mb-4">
                        {hotel.description}
                      </p>

                      {/* Amenities */}
                      <div className="flex items-center space-x-3 mb-4">
                        {hotel.amenities.map((Amenity, index) => (
                          <div key={index} className="w-8 h-8 bg-amber-50 rounded-full flex items-center justify-center">
                            <Amenity size={16} className="text-amber-600" />
                          </div>
                        ))}
                      </div>

                      {/* Highlights */}
                      <div className="mb-6">
                        <div className="flex flex-wrap gap-1">
                          {hotel.highlights.slice(0, 2).map((highlight, index) => (
                            <span key={index} className="bg-blue-50 text-blue-700 px-2 py-1 rounded text-xs">
                              ✓ {highlight}
                            </span>
                          ))}
                          {hotel.highlights.length > 2 && (
                            <span className="text-blue-600 text-xs font-medium">
                              +{hotel.highlights.length - 2} services
                            </span>
                          )}
                        </div>
                      </div>

                      {/* CTA */}
                      <div className="flex gap-3">
                        <Button className="flex-1 text-sm py-2">
                          Réserver
                        </Button>
                        <button className="px-4 py-2 border border-gray-200 rounded-lg hover:border-amber-600 hover:text-amber-600 transition-colors text-sm">
                          Détails
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              </div>
            )}
          </div>
        </div>

        {/* Custom quote section */}
        <div className="mt-16 bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">Besoin d'un Séjour Sur Mesure ?</h3>
          <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
            Notre équipe d'experts crée des packages personnalisés selon vos préférences : 
            budget, dates, activités, et type d'hébergement.
          </p>
          <Button variant="secondary" size="lg">
            Demander un devis gratuit
          </Button>
        </div>

        {/* View all button */}
        <div className="text-center mt-12">
          <Button variant="outline" size="lg">
            Voir tous les hôtels
          </Button>
        </div>
      </div>
    </section>
  );
}